// for user story 3.1.4
const API_BASE =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000/api';

export async function fetchSmokingBenchmark() {
  const res = await fetch(`${API_BASE}/open-data/smoking-benchmarks`);

  if (!res.ok) {
    throw new Error('Failed to load smoking benchmark.');
  }

  return res.json();
}